
import { useState, useEffect } from 'react';

export const useLeafletMap = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Skip if already loaded or has an error
    if (isLoaded || error || document.getElementById('leaflet-css') || document.getElementById('leaflet-js')) {
      if (document.getElementById('leaflet-css') && document.getElementById('leaflet-js')) {
        setIsLoaded(true);
      }
      return;
    }

    // Load CSS
    const cssLink = document.createElement('link');
    cssLink.id = 'leaflet-css';
    cssLink.rel = 'stylesheet';
    cssLink.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    cssLink.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    cssLink.crossOrigin = '';
    
    // Load JS
    const script = document.createElement('script');
    script.id = 'leaflet-js';
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    script.crossOrigin = '';
    script.async = true;
    script.defer = true;
    
    // Handle errors
    cssLink.onerror = () => {
      setError('Failed to load Leaflet CSS');
      console.error('Failed to load Leaflet CSS');
    };
    
    script.onerror = () => {
      setError('Failed to load Leaflet JS');
      console.error('Failed to load Leaflet JS');
    };

    script.onload = () => {
      setIsLoaded(true);
      console.log("Leaflet loaded successfully");
    };

    // Add the script and CSS to the document
    document.head.appendChild(cssLink);
    document.head.appendChild(script);

    // Clean up
    return () => {
      // We don't remove the scripts once loaded as they might be needed elsewhere
      // and removing them could break the application
    };
  }, [isLoaded, error]);

  return { isLoaded, error };
};
